import Edit from "@mui/icons-material/Edit";
import { Tooltip } from "@mui/material";
import { GridApiCommon, GridRowId } from "@mui/x-data-grid";
import React, { ReactElement, useCallback } from "react";
import { ReactNode } from "react";

import { PlanEditableFields, usePlanIsChanged } from "@/stores/use-plan-table";

import HistoryInfo from "./HistoryInfo";

// Define the component as a generic function first
const MemoizedEditableColumn = <T,>({
    field,
    id,
    editable = true,
    children,
    className,
    api,
    handleEdit,
    renderHistoryComp,
}: {
    editable?: boolean;
    children: ReactNode;
    className?: string;
    field: string;
    id: GridRowId;
    api: GridApiCommon;
    handleEdit?: () => void;
    renderHistoryComp: (value: T) => ReactElement<{}>;
}) => {
    const isChanged = usePlanIsChanged(id, field as keyof PlanEditableFields);

    const handleClick = useCallback(
        (e: React.MouseEvent) => {
            if (!editable) return;
            e.stopPropagation();
            if (handleEdit) {
                return handleEdit();
            }
            if (api) api.startCellEditMode({ field, id });
        },
        [field, handleEdit, editable, api, id]
    );

    return (
        <div
            onDoubleClick={handleClick}
            className={
                `flex h-full items-center pl-4 pr-2 group relative  ` +
                (className || "") +
                ((isChanged && " bg-yellow-100") || "bg-transparent")
            }
        >
            {children}

            {editable && (
                <Tooltip title="Güncelle" arrow>
                    <Edit
                        onClick={handleClick}
                        className="text-gray-300 hover:text-elitBlue ml-2 hover:scale-105 active:scale-95 cursor-pointer  !opacity-0  translate-x-[200px] group-hover:!translate-x-0 group-hover:!opacity-100 duration-200 white-on-cancelled"
                        sx={{ fontSize: "16px", transitionDuration: "200ms" }}
                    />
                </Tooltip>
            )}
            <HistoryInfo id={id} field={field} renderHistoryComp={renderHistoryComp} />
        </div>
    );
};

export default MemoizedEditableColumn;
